import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import {time_ago_txt} from 'Skelet/src/modules/time_ago.js'
import {handleChange} from 'Skelet/src/modules/functions.js';


class EventSearch extends React.Component {

  constructor(props) {
    super(props);

    let adE = this.props.apiData["event_search"];
    this.state = {
      ext_id: (adE !== undefined && adE.data && adE.data[0] !== undefined) ? adE.data[0].ext_id : ""
    };
  }

  render() {
    let cards = null, ttv_card = null, end_of_list_text = "", page_cards = this.props.apiData["event_search"], ttv_info = this.props.apiData["ttv_info"];

    let has_data = page_cards !== undefined && page_cards.data !== undefined && page_cards.data !== null && page_cards.data[0] !== undefined;
    if(has_data) {
      let card_items = page_cards.data.map(function(item, i) {
        item.time_ago_txt = time_ago_txt(item.created_on);

        return <div key={"1k"+i} style={{marginBottom:"1em"}}>
          <div className="contact-name">[{item.app_id}] [{item.label}] {item.ext_id}</div>
          <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.time_ago_txt}</small>
          <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.country} &middot; {item.created_on}</small>
        </div>;
      });
      cards = <div className="card">{card_items}</div>;
    }

    let ttv_has_data = ttv_info !== undefined && ttv_info.data !== undefined && ttv_info.data !== null && ttv_info.data[0] !== undefined;
    if(ttv_has_data) {
      let item = ttv_info.data[0];
      item.time_ago_txt = time_ago_txt(item.created_on);
      item.time_ago_txt2 = time_ago_txt(item.updated_on);
      item.fpvr = (parseInt(item.followers, 10) / parseInt(item.views, 10) * 100).toFixed(1);

      ttv_card = <div className="card">
        <div>[{item.ext_id}] <a href={"https://twitch.tv/"+item.name+"/about"} target="_blank">{item.name}</a></div>
        <div style={{color:"#9347FF"}}>{parseInt(item.followers, 10).toLocaleString()} followers &middot; <span style={{opacity:".6"}}>{parseInt(item.views, 10).toLocaleString()} views</span> &middot; {item.fpvr}%</div>
        <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.time_ago_txt} &middot; {item.time_ago_txt2}</small>
        <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.created_on} &middot; {item.updated_on}</small>
      </div>;
    }

    if(page_cards !== undefined && page_cards.isFetching) {
      end_of_list_text = "Laden..";
    } else if((page_cards !== undefined && !page_cards.isFetching)) {
      if(has_data && ttv_has_data) {
        end_of_list_text = "Einde van resultaten.";
      } else if(has_data && !ttv_has_data) {
        end_of_list_text = "Geen TTV Info.";
      } else if(!has_data && ttv_has_data) {
        end_of_list_text = "Geen events.";
      } else {
        end_of_list_text = "Geen events of TTV Info.";
      }
    }

    return (
      <div className="container content" ref={this.setWrapperRef}>
        <div className="card settings">
          <form onSubmit={(e) => this.handleSubmit(e)}>
            <div><input type="text" value={this.state.ext_id} onChange={(e) => handleChange(this, "ext_id", e)} placeholder="ext_id" /></div>
            <div className="form-actions"><input type="submit" value="ophalen" disabled={this.props.event_search_is_fetching} /></div>
          </form>
        </div>
        {ttv_has_data && ttv_card}
        {has_data && cards}
        <div className="end_of_list_text">{end_of_list_text}</div>
      </div>
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.props.event_search_is_fetching === false || this.props.event_search_is_fetching === null) {
      this.props.fetchDataIfReady(config.api_token, "event_search", "GET", config.api_url+"/event-search?t="+this.props.session_token+"&ext_id="+this.state.ext_id, undefined, null, true);
      this.props.fetchDataIfReady(config.api_token, "ttv_info", "GET", config.api_url+"/ttv-channel-search?t="+this.props.session_token+"&ext_id="+this.state.ext_id, undefined, null, true);
    }
  }

}


function mapStateToProps(state) {
  let session_token = null, event_search_is_fetching = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["event_search"] !== undefined && state.apiData["event_search"].isFetching !== undefined) {
    event_search_is_fetching = state.apiData["event_search"].isFetching;
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
    event_search_is_fetching: event_search_is_fetching,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EventSearch)



// WEBPACK FOOTER //
// ./src/containers/EventSearch.js